"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_CATALOG_CATEGORY = exports.SET_CATALOG_CATEGORY_GROUP = exports.SET_CATALOG_SERIES = exports.SET_CATALOG_SERIES_TYPE = void 0;
exports.SET_CATALOG_SERIES_TYPE = 'SET_CATALOG_SERIES_TYPE';
exports.SET_CATALOG_SERIES = 'SET_CATALOG_SERIES';
exports.SET_CATALOG_CATEGORY_GROUP = 'SET_CATALOG_CATEGORY_GROUP';
exports.SET_CATALOG_CATEGORY = 'SET_CATALOG_CATEGORY';
